import { render, staticRenderFns } from "./RelationshipsAddresses.vue?vue&type=template&id=239b1ecc&"
import script from "./RelationshipsAddresses.vue?vue&type=script&lang=js&"
export * from "./RelationshipsAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports